import { getLocale } from '../utils/utils';

export const xApiKey = '48e8e814-3eaa-4c11-bc9e-f5092f755739';
export const token = 'ddc5e6db131a4b04a566876e857b24d2';
export const lang = 'en';
export const baseURL = 'https://poweris.inhandnetworks.com';
export const locale = getLocale();

export const region = null;
